import categoryService from "../../services/category.service";
import countryService from "../../services/country.service";


    export const state ={
        categories:[],
        subcategories:[],

    }
    export const actions = {
        fetch_categories({commit}, page){
            return categoryService.get_categories(page).then(
                data => {
                    // console.log(data);
                    
                    commit ('SET_CATEGORIES', data.data);
                    return Promise.resolve(data.data);
                }, error => {
                    // commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },
        fetch_totals({commit},){
            return  countryService.fetch_totals().then(
                data => {
                    // console.log(data);
                    
                    commit ('SET_TOTALS', data.data);
                    return Promise.resolve(data.data);
                }, error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },

    }
    export const mutations = {
        
        SET_CATEGORIES(state,payload){
            state.categories = payload.categories
            // state.cities = payload.cities.data
        },
        SET_TOTALS(state,totals){
            state.totals = totals
        },
       
    }
    export const getters = {
        get_categories(state){
            return state.categories
        },
        get_states(state){
            return state.states
        },
        

    }


